module.exports = __webpack_public_path__ + "img/9.6626a2aa.png";